import { render } from "./ThirdBodyTemplate.vue?vue&type=template&id=f7cf47c0&scoped=true"
import script from "./ThirdBodyTemplate.vue?vue&type=script&lang=js"
export * from "./ThirdBodyTemplate.vue?vue&type=script&lang=js"

import "./ThirdBodyTemplate.vue?vue&type=style&index=0&id=f7cf47c0&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7cf47c0"]])

export default __exports__